/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityDto,
    IdentityDtoFromJSON,
    IdentityDtoFromJSONTyped,
    IdentityDtoToJSON,
} from './IdentityDto';

/**
 * 
 * @export
 * @interface GroupDto
 */
export interface GroupDto {
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    groupName?: string;
    /**
     * 
     * @type {Array<IdentityDto>}
     * @memberof GroupDto
     */
    identities?: Array<IdentityDto>;
}

export function GroupDtoFromJSON(json: any): GroupDto {
    return GroupDtoFromJSONTyped(json, false);
}

export function GroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'identities': !exists(json, 'identities') ? undefined : ((json['identities'] as Array<any>).map(IdentityDtoFromJSON)),
    };
}

export function GroupDtoToJSON(value?: GroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupName': value.groupName,
        'identities': value.identities === undefined ? undefined : ((value.identities as Array<any>).map(IdentityDtoToJSON)),
    };
}

